
import Bunyan from 'bunyan';
const  log = Bunyan.createLogger({name: "Stack"});

import { QUEUE, NONE } from '../constants/types';
import Collection from './collection';

class Queue extends Collection { 

  TYPE = QUEUE;

  _add(value, _value) { 
    value.unshift(_value);
    return value;
  }

  _next(value) { 
    const nextValue = value.pop();
    return { nextValue, value };
  }

}

export default Queue;